import {
  aqua,
  orange, purple,
  salmon,
  sanguine, spaceCadet, ultraMarine,
} from '../../../utils/colors';

const colorClasses = {
  '&.SpaceCadet': {
    backgroundColor: spaceCadet[300],
    color: spaceCadet[500],
  },
  '&.Sanguine': {
    backgroundColor: sanguine[300],
    color: sanguine[600],
  },
  '&.UltraMarine': {
    backgroundColor: ultraMarine[300],
    color: ultraMarine[600],
  },
  '&.Orange': {
    backgroundColor: orange[300],
    color: orange[500],
  },
  '&.Salmon': {
    backgroundColor: salmon[300],
    color: salmon[500],
  },
  '&.Purple': {
    backgroundColor: purple[300],
    color: purple[600],
  },
  '&.Aqua': {
    backgroundColor: aqua[300],
    color: aqua[600],
  },
  '&.transparent': {
    backgroundColor: 'transparent',
  },
};
export default colorClasses;
